import type { WalkthroughRole } from '../../content/help/walkthroughTypes';

export interface SendHelpPayload {
  role: WalkthroughRole;
  recipient?: string;
  message: string;
}

// CB:BEGIN future-send-help-adapter
export const sendHelpMessage = async (_payload: SendHelpPayload): Promise<{ ok: boolean; mode: 'placeholder' }> => {
  // Placeholder adapter for future email/chat integration.
  return { ok: true, mode: 'placeholder' };
};
// CB:END future-send-help-adapter

